import { motion } from "framer-motion";
import AuthLayout from "../../../shared/Layouts/AuthLayout";
import { useState } from "react";
import { CALENDER, ENVELOPE, PAD_LOCK, PROFILE, USER } from "../../../assets";
import LinkHead from "../../../shared/components/LinkHead";
import { useNavigate } from "react-router-dom";
import { FaCheck, FaEye, FaEyeSlash } from "react-icons/fa";
import ButtonV2 from "../../../shared/components/buttonV2";
import { MdPhone } from "react-icons/md";
import { useAppDispatch } from "../../../hooks";
import { register } from "../../../Services/auth";
import { RegisterTypes } from "../../../types";
import { toast } from "react-hot-toast";
import {
  setStoredEmail,
  setVerifyType,
} from "../../../states/slices/globalReducer";

const signUpTypes = [
  {
    role: "Individual",
    description:
      "Search for properties under litigation, access and download certificates of Lis Pendens, and track the status of property disputes.",
    signUpType: "individual",
  },
  {
    role: "Company",
    description:
      "Upload new litigation records, update case statuses, manage court and registry records, and ensure accurate data in the system.",
    signUpType: "company",
  },
];
const SignUp = () => {
  const navigate = useNavigate();
  const [signUpType, setSignUpType] = useState<string | null>(null);

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [checked, setChecked] = useState(false);
  const dispatch = useAppDispatch();
  const [formInput, setFormInput] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    phone_number: "",
    dob: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "phone_number") {
      let inputNumber = value.replace(/\D/g, ""); // remove non-numeric values

      if (inputNumber.length > 11) inputNumber = inputNumber.slice(0, 11);
      setFormInput((prev) => ({
        ...prev,
        phone_number: inputNumber,
      }));
    } else {
      const noSpaced = value.replace(/\s/g, "");
      setFormInput((prev) => ({
        ...prev,
        [name]: noSpaced,
      }));
    }
  };

  const passwordPattern =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]+$/;

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const disbled =
    formInput.first_name === "" ||
    formInput.last_name === "" ||
    formInput.email === "" ||
    !passwordPattern.test(formInput.password) ||
    formInput.phone_number === "" ||
    formInput.dob === "" ||
    !checked;

  const reset = () =>
    setFormInput({
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      phone_number: "",
      dob: "",
    });
  const handleRegister = async () => {
    setLoading(true);
    try {
      const payload: RegisterTypes = {
        name: formInput.first_name + " " + formInput.last_name,
        dob: formInput.dob,
        email: formInput.email,
        password: formInput.password,
        phone_number: formInput.phone_number,
        type: signUpType,
      };

      const response = await register(payload);
      if (response) {
        toast.success(response?.message);
        window.history.pushState({}, "", "/verify-otp");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        dispatch(setStoredEmail(formInput.email));
        dispatch(setVerifyType("REGISTER"));
        reset();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <LinkHead title="Sign up" content="." />
      <AuthLayout>
        {!signUpType ? (
          <div className="flex items-center justify-center flex-col gap-y-5 max-h-full">
            <div className="flex flex-col items-center gap-y-2">
              <span className="text-customDark font-semibold lg:text-start text-3xl text-center lg:leading-normal leading-[40px] lg:text-[32px]">
                Who do you want to signup as
              </span>
              <span className="text-sm font-normal text-primary-50 text-center">
                Select your role to personalize your experience and access the
                right features for your responsibilities within the Lis Pendens
                Anambra system.
              </span>
            </div>
            <div className="flex items-start lg:flex-row flex-col gap-3 w-full">
              {signUpTypes.map((item) => (
                <div
                  onClick={() =>
                    // @ts-ignore
                    setSignUpType(item.signUpType)
                  }
                  className="w-full h-full hover:scale-105 transition-all duration-300 hover:bg-gray-100 cursor-pointer border p-10 border-borderColor rounded-xl flex flex-col gap-y-2 items-center justify-center"
                >
                  <img src={PROFILE} alt="" />
                  <span className="font-semibold text-[#303237] text-lg text-center">
                    {item.role}
                  </span>
                  <p className="text-sm lg:block hidden font-medium text-primary-50 text-center">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="lg:w-[40rem] w-full  h-fit lg:mt-0 mt-10 shadow-boxShadow rounded-lg lg:p-10 p-5 flex flex-col gap-y-6 items-start"
          >
            <div className="flex flex-col gap-y-2">
              <span className="text-2xl font-bold text-primary-300">
                Create account
              </span>
              <span className="text-primary-300 font-normal text-sm">
                Already have an account?{" "}
                <span
                  className="text-globalGold font-medium cursor-pointer"
                  onClick={() => navigate("/sign-in")}
                >
                  Login
                </span>
              </span>
            </div>
            <form action="" className="flex flex-col gap-y-4">
              <div className="flex lg:flex-row flex-col gap-y-3 items-start w-full gap-x-4">
                <div className="flex flex-col items-start w-full gap-y-1">
                  <span className="text-sm font-medium text-[#4F5762]">
                    First Name
                  </span>
                  <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                    <img src={USER} className="w-[20px] h-[20px]" alt="" />
                    <input
                      type="text"
                      name="first_name"
                      value={formInput.first_name}
                      onChange={handleInputChange}
                      placeholder="First Name"
                      className="bg-transparent placeholder:text-sm w-full outline-none text-primary-300"
                    />
                  </div>
                </div>
                <div className="flex flex-col items-start w-full gap-y-1">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Last Name
                  </span>
                  <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                    <img src={USER} className="w-[20px] h-[20px]" alt="" />
                    <input
                      type="text"
                      name="last_name"
                      value={formInput.last_name}
                      onChange={handleInputChange}
                      placeholder="Last Name"
                      className="bg-transparent placeholder:text-sm  w-full outline-none text-primary-300"
                    />
                  </div>
                </div>
              </div>
              <div className="flex lg:flex-row flex-col gap-y-3 items-start w-full gap-x-4">
                <div className="flex flex-col items-start w-full gap-y-1">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Email
                  </span>
                  <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                    <img src={ENVELOPE} className="w-[20px] h-[20px]" alt="" />
                    <input
                      type="text"
                      placeholder="Email"
                      name="email"
                      value={formInput.email}
                      onChange={handleInputChange}
                      className="bg-transparent placeholder:text-sm  w-full outline-none text-primary-300"
                    />
                  </div>
                  {formInput.email && !emailRegex.test(formInput.email) && (
                    <span className="text-xs font-normal text-red-500">
                      Kindly use a valid email address
                    </span>
                  )}
                </div>
                <div className="flex flex-col items-start w-full gap-y-1">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Phone Number
                  </span>
                  <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                    {/* <img src={ENVELOPE} className="w-[20px] h-[20px]" alt="" /> */}
                    <MdPhone size={20} color="#808080" />
                    <input
                      type="text"
                      name="phone_number"
                      value={formInput.phone_number}
                      onChange={handleInputChange}
                      placeholder="Phone Number"
                      className="bg-transparent placeholder:text-sm  w-full outline-none text-primary-300"
                    />
                  </div>
                </div>
              </div>
              <div className="flex lg:flex-row flex-col gap-y-3 items-start w-full gap-x-4">
                <div className="flex flex-col items-start w-full gap-y-1">
                  <span className="text-sm font-medium text-[#4F5762]">
                    DOB
                  </span>
                  <div className="w-full h-[48px] justify-between rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                    <div className="flex items-center gap-x-2">
                      <img
                        src={CALENDER}
                        className="w-[20px] h-[20px]"
                        alt=""
                      />

                      <input
                        type="date"
                        name="dob"
                        value={formInput.dob}
                        onChange={handleInputChange}
                        max={
                          new Date(
                            new Date().setFullYear(
                              new Date().getFullYear() - 18,
                            ),
                          )
                            .toISOString()
                            .split("T")[0]
                        }
                        className="bg-transparent placeholder:text-sm w-full outline-none text-primary-300"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start w-full gap-y-1">
                  <span className="text-sm font-medium text-[#4F5762]">
                    Password
                  </span>
                  <div className="w-full h-[48px] justify-between rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                    <div className="flex items-center gap-x-2">
                      <img
                        src={PAD_LOCK}
                        className="w-[20px] h-[20px]"
                        alt=""
                      />

                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formInput.password}
                        onChange={handleInputChange}
                        placeholder="******************"
                        className="bg-transparent placeholder:text-sm  w-full outline-none text-primary-300"
                      />
                    </div>
                    {showPassword ? (
                      <span
                        className="cursor-pointer "
                        onClick={() => setShowPassword(false)}
                      >
                        <FaEyeSlash color="#808080" />
                      </span>
                    ) : (
                      <span
                        className="cursor-pointer"
                        onClick={() => setShowPassword(true)}
                      >
                        <FaEye color="#808080" />
                      </span>
                    )}
                  </div>
                  {formInput.password &&
                    !passwordPattern.test(formInput.password) && (
                      <span className="text-xs font-normal text-red-500">
                        Password must contain uppercase, lowercase, a number,
                        and a special character.
                      </span>
                    )}
                </div>
              </div>

              <div className="flex items-center gap-x-3">
                <div
                  onClick={() => setChecked((prev) => !prev)}
                  className="min-w-[20px]  cursor-pointer  min-h-[20px] border border-[#D2D5DA]  rounded flex items-center justify-center"
                >
                  {checked && <FaCheck color="#00a63e" size={15} />}
                </div>
                <span className=" lg:text-sm text-xs font-medium text-primary-50">
                  By clicking, you accept our{" "}
                  <span
                    onClick={() => navigate("/privacy-policy")}
                    className="text-globalGold cursor-pointer"
                  >
                    Terms of service
                  </span>{" "}
                  and{" "}
                  <span
                    onClick={() => navigate("/privacy-policy")}
                    className="text-globalGold cursor-pointer"
                  >
                    Privacy policy
                  </span>
                </span>
              </div>
              <ButtonV2
                title={"Create Account"}
                loading={loading}
                disabled={loading || disbled}
                loaderColor="#ffffff"
                btnStyle={
                  "bg-globalGold rounded-lg w-full mt-5 h-[45px] flex items-center justify-center"
                }
                textStyle={"text-white text-[16px] text-semibold"}
                handleClick={handleRegister}
              />
            </form>
          </motion.div>
        )}
      </AuthLayout>
    </>
  );
};

export default SignUp;
